import Axios from 'axios';
import { common } from '../config/configuration';
export default abstract class BaseApi {
  public BASE_URL: string;
  constructor() {
    this.BASE_URL = common.apiUrl;
  }
  private async sendRequest(
    url: string,
    method: RequestMethod,
    data: any,
    secure: boolean = false,
  ): Promise<any> {
    data.latitude = data.latitude ?? '';
    data.longitude = data.longitude ?? '';
    // let header: any = {
    //   'Content-Type': 'text',
    //   Accept: 'text',
    //   'Accept-Encoding': 'gzip, deflate, br',
    //   Connection: 'keep-alive',
    //   'Cache-Control': 'no-cache',
    //   Pragma: 'no-cache',
    //   Expires: '0',
    // };
    let header: any = {
      "Content-Type": "application/json",
}
    // if (secure) {
    //   header.Authorization = await AsyncStorage.getItem('ACCESS_TOKEN');
    // }
    try {
      let resp = await Axios({
        method: method,
        url: url,
        baseURL: this.BASE_URL,
        data: data,
        headers: header,
        params: method.toUpperCase() == 'GET' ? data : {},
        transformResponse: [
          function (res) {
            //  console.log(data, res, url);
            return JSON.parse(res);
          },
        ],
      });
      if (resp.status != 404) {
        return resp.data as any;
      }
    } catch (e: any) {
      //console.log(e, this.BASE_URL, url, data, method);
      return {status: false, message: e.message} as any;
    }
    return {
      status: false,
      message: 'Some error occures please try again',
    } as any;
  }

  public async getOpenApi(url: string, data: any) {
    return await this.sendRequest(url, RequestMethod.GET, data);
  }
  public async getSecureApi(url: string, data: any) {
    return await this.sendRequest(url, RequestMethod.GET, data, true);
  }
  public async putOpenApi(url: string, data: any) {
    return await this.sendRequest(url, RequestMethod.PUT, data);
  }
  public async putSecureApi(url: string, data: any) {
    return await this.sendRequest(url, RequestMethod.PUT, data, true);
  }
  public async postOpenApi(url: string, data: any) {
    return await this.sendRequest(url, RequestMethod.POST, data);
  }
  public async postSeucreApi(url: string, data: any) {
    return await this.sendRequest(url, RequestMethod.POST, data, true);
  }
  public async deleteOpenApi(url: string, data: any) {
    return await this.sendRequest(url, RequestMethod.DELETE, data);
  }
  public async deleteSecureApi(url: string, data: any) {
    return await this.sendRequest(url, RequestMethod.DELETE, data, true);
  }
}
export enum RequestMethod {
  GET = 'GET',
  POST = 'POST',
  DELETE = 'DELETE',
  PUT = 'PUT',
}
